export default {
      id: "filter-asc-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "assets/sprite.svg#filter-asc-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/filter-asc.svg
// module id = ./assets/svg/filter-asc.svg
// module chunks = 0